import React, { Component } from 'react';
import { ChevronIcon2, CloseIcon, FeedbackIcon } from './SVGIcons';

import Social from './Social'
import OffcanvasForm from './OffcanvasForm';

class Window extends Component {
  state = {
    showForm: false
  };

  componentDidMount() {
    // Блокировка прокрутки body при открытии
    if (this.props.show) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentDidUpdate(prevProps) {
    // Блокировка/разблокировка прокрутки при изменении состояния
    if (this.props.show !== prevProps.show) {
      document.body.style.overflow = this.props.show ? 'hidden' : 'unset';
    }
  }

  componentWillUnmount() {
    // Возвращаем прокрутку при размонтировании
    document.body.style.overflow = 'unset';
  }

  handleBackdropClick = (e) => {
    // Закрываем только при клике на backdrop, не на содержимое
    if (e.target === e.currentTarget && this.props.onHide) {
      this.props.onHide();
    }
  };

  // Метод для открытия формы
  openForm = () => {
    this.setState({ showForm: true });
  };

  // Метод для закрытия формы
  closeForm = () => {
    this.setState({ showForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    // Закрываем модальное окно Window
    if (this.props.onHide) {
      this.props.onHide();
    }
    // Показываем сообщение об успехе
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {
    const { show, onHide, className = '', data } = this.props;
    const { showForm } = this.state;

    if (!show) return null;

    return (
      <>
        {/* Затемнение фона (backdrop) */}
        <div 
          className="fixed inset-0 bg-black/50 z-50 transition-opacity duration-300"
          style={{
            animation: 'fadeIn 0.3s ease-out'
          }}
          onClick={this.handleBackdropClick}
        >
          {/* Контейнер для центрирования */}
          <div className="flex items-center justify-center min-h-full p-2.5">
            {/* Модальное окно */}
            <div 
              className={`
                relative bg-white rounded-[15px] w-full max-w-[559px] 
                shadow-xl transition-all duration-300
                ${className}
              `}
              style={{
                animation: 'slideIn 0.3s ease-out'
              }}
            >
              {/* Кнопка закрытия */}
              <button
                onClick={onHide}
                className="absolute top-3 right-3 z-10 p-2 hover:opacity-70 transition-opacity"
                aria-label="Закрыть"
              >
                <CloseIcon width={16} height={16} fill="black" />
              </button>

              <div className='w-full flex flex-col sm:flex-row items-start justify-between px-[20px] py-[30px] leading-none tracking-[-0.04em]'>
                <div className='flex-1'>
                  <div className='w-full items-center flex justify-center sm:justify-start'>
                    <div className='h-[38px] bg-[#F5F7F9] rounded-full px-[15px] inline-flex items-center gap-[9px]'>
                      <FeedbackIcon />
                      <div className='text-[#032432]/60 text-[14px]'>Обратная связь</div>
                    </div>
                  </div>
                  <div className='mt-[15px] text-[#032432] text-[24px] sm:text-[32px] text-center sm:text-start'>Мы всегда на связи <span className='text-[#032432]/60'>в мессенджерах!</span></div>
                  <div className='mt-[10px] text-black/60 text-[12px] sm:text-[14px] text-center sm:text-start'>Напишите или позвоните для консультации</div>
                  <img className='hidden sm:block mt-[73px]' src={data?.mlogo} alt="химавангард" width={204} height={53} />
                  <div className='hidden sm:flex items-center gap-[5px] mt-[9px]'>
                    {/* Кнопка Оставить заявку с открытием формы */}
                    <div 
                      className='flex items-center gap-[9px] h-[40px] px-[35px] bg-[#009EE3] text-white rounded-full cursor-pointer hover:bg-[#0082c0] transition-colors duration-300'
                      onClick={this.openForm}
                    >
                      <div className='text-[12px] xl:text-[14px]'>Оставить заявку</div>
                      <ChevronIcon2 stroke="white" />
                    </div>
                    <Social social={data?.social || []} width={40} />
                  </div>
                </div>
                <div className='flex-none mx-auto sm:mx-0'>
                  <div className='w-[175px] h-[175px] sm:w-[203px] sm:h-[203px] bg-[#F5F7F9] rounded-[15px] flex items-center justify-center'>
                    <img src={data?.qr} alt="qr" width={179} height={179} className='w-[154px] h-[154px] sm:w-[179px] sm:h-[179px]' />
                  </div>
                  <div className='w-[175px] sm:w-[203px] bg-[#F5F7F9] rounded-[15px] p-[15px]'>
                    <div className='text-[#032432] text-[16px] sm:text-[18px]'>Хотите позвонить?</div>
                    <div className='mt-[2px] text-[12px] sm:text-[14px] text-black/60'>Нажмите для звонка</div>
                    <a href={`tel:${data?.phone?.replace(/[-()\s]/g, '')}`} className='block mt-[13px] text-[#009EE3] text-[16px] sm:text-[22px]'>{data?.phone}</a>
                  </div>
                </div>
                <img className='sm:hidden mt-[15px] mx-auto' src={data?.mlogo} alt="химавангард" width={204} height={53} />
                <div className='flex sm:hidden items-center justify-center gap-[5px] mt-[5px] w-full'>
                  {/* Кнопка Оставить заявку для мобильной версии */}
                  <div 
                    className='flex items-center gap-[9px] h-[40px] px-[35px] bg-[#009EE3] text-white rounded-full cursor-pointer hover:bg-[#0082c0] transition-colors duration-300'
                    onClick={this.openForm}
                  >
                    <div className='text-[12px] xl:text-[14px]'>Оставить заявку</div>
                    <ChevronIcon2 stroke="white" />
                  </div>
                  <Social social={data?.social || []} width={40} />
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Форма обратной связи */}
        <OffcanvasForm
          show={showForm}
          hide={this.closeForm}
          formTitle="Оставить заявку"
          productName="" // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />

        {/* Стили для анимаций */}
        <style jsx>{`
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
          
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: scale(0.95) translateY(-10px);
            }
            to {
              opacity: 1;
              transform: scale(1) translateY(0);
            }
          }
        `}</style>
      </>
    );
  }
}

export default Window;